import React from 'react';
import { withRouter } from 'react-router-dom';

class AboutUs extends React.Component {
    render() {
        return (
            <div className="section">
                <div className="container">
                    <div className="columns">
                        <div className="column">
                            <div className="content">
                                <h1 className="title">Your Dream Our Service</h1>
                                <p>
                                    myhomekart.com is a platform to provide realtor services to customers across Mumbai. We connect with housing societies to provide genuine and authentic property listings on our website. We are a talented pool of Professionals with almost 3 decades of experience put together in Sales & financial Services and IT.
                                </p>
                                <p>
                                    A property transaction be it Purchase, Sale or Rent, is the most expensive, tedious and time consuming transaction that most of us ever make in our lifetime. It often involves one's life's savings and encumbers us with a lifelong burden of EMI's. For such a vital and expensive decision fraught with risks, the consumers neither get the research nor the support that they deserve.
                                </p>
                                <p>
                                    While looking for a property, in the initial stages, one wants to understand the overall real estate landscape of the city and good locations in terms of connectivity, readiness, livability, value for money etc. In the later stage, once the search is narrowed down, to best available options that money can buy one wants to understand the 'real' on the ground information like legal status of the project, Government clearances, builders reputation, past project delivery, and civic infrastructure etc. The deal making therefore needs to be less stressful and this can be enabled by us providing all the relevant details digitally from seller to the buyer.
                                </p>
                                <p>
                                    myhomekart.com is created to solve these problems faced by both buyer and seller of the flats. Myhomekart provides a digital platform where all the relevant details are available on a single click.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(AboutUs);



// WEBPACK FOOTER //
// ./src/app/routes/about-us/index.js